"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FailedTextWrapper = exports.HeaderWrapper = void 0;
const components_core_1 = require("@volkswagen-onehub/components-core");
exports.HeaderWrapper = components_core_1.styled.div `
  width: 80%;
  padding-bottom: 18px;
  @media (min-width: ${components_core_1.Breakpoints.b560}px) {
    width: 70%;
  }
  @media (min-width: ${components_core_1.Breakpoints.b1280}px) {
    width: 100%;
  }
`;
exports.FailedTextWrapper = components_core_1.styled.div `
  width: 90%;
  padding-bottom: 64px;
  @media (min-width: ${components_core_1.Breakpoints.b560}px) {
    width: 50%;
    padding-bottom: 74px;
  }
  @media (min-width: ${components_core_1.Breakpoints.b1280}px) {
    width: 30%;
  }
`;
